import Button from "components/Button";
import { StepProps } from "../Form";
import FormNav from "../FormNav";
import FormStyles from "../styled";

const ChooseType = (props: StepProps) => {
  const _onClick = (type: string) => {
    props.onClick(type);

    if (props.nextStep) {
      props.nextStep();
    }
  };

  return (
    <FormStyles.Step>
      <FormStyles.StepContent>
        <FormStyles.ButtonsGroup>
          <p>Choose the player's type:</p>
          <Button onClick={_onClick.bind(null, "pitcher")} active={props.type === "pitcher"}>
            Pitcher
          </Button>
          <Button onClick={_onClick.bind(null, "batter")} active={props.type === "batter"}>
            Batter
          </Button>
        </FormStyles.ButtonsGroup>
      </FormStyles.StepContent>
      <FormNav {...props} />
    </FormStyles.Step>
  );
};

export default ChooseType;
